/**
 * Copyright 2025 Phenix Real Time Solutions, Inc. Confidential and Proprietary. All Rights Reserved.
 */

import PropTypes from 'prop-types';
import Select from './Select';
import {frameRates} from '../data/FrameRates';

export const FrameRateSelect = ({defaultValue, onChange, disabled}) => {
  const options = frameRates.map(frameRate => ({
    value: frameRate.value,
    label: frameRate.label
  }));

  return (
    <Select
      defaultValue={defaultValue}
      onChange={onChange}
      disabled={disabled}
      options={options}
    />
  );
};

FrameRateSelect.propTypes = {
  defaultValue: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired
};